module.exports = __webpack_public_path__ + "img/remen_product2.ce0f6964.png";